import { useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Box, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Icon } from './Icons';
import { withRoomClientContext } from '../lib/RoomClientContext';

function VideoFrame({ stream }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const videoRef = useRef(null);
  const { hideVideo } = useSelector((state) => state.device);

  useEffect(() => {
    if (videoRef.current && stream) {
      videoRef.current.srcObject = hideVideo ? null : stream;
    }
  }, [stream, hideVideo]);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        width: '400px', // Fixed width to maintain size
        height: '30vh', // Fixed height to maintain size
        maxWidth: '90vw', // Adjust the maximum width as needed
      }}
    >
      <video
        ref={videoRef}
        playsInline
        muted
        controls={false}
        autoPlay
        aria-label={t('Camera preview')}
        style={{
          width: '100%',
          height: '100%',
          transform: 'scaleX(-1)',
          objectFit: 'cover', // Ensure the video covers its container while preserving aspect ratio
          display: hideVideo ? 'none' : 'block', // Hide the video element when hideVideo is true
        }}
      />
      {hideVideo && (
        <Stack alignItems="center">
          <Icon name="videoOff" color={theme.palette.black} />
          <Typography sx={{ fontSize: '12px' }}>
            {t('Your camera is off')}
          </Typography>
        </Stack>
      )}
    </Box>
  );
}

const VideoFrameWrapper = ({ roomClient }) => {
  const stream = roomClient.streamHandler._videoStream;
  return <VideoFrame stream={stream} />;
};

export default withRoomClientContext(VideoFrameWrapper);
